import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useIsomorphicLayoutEffect } from './e6bd8d9d193665651547f77cb2adacf0dae81d061654707a931bdfc0fd619642.cfe-internal.js';
import { useCollector } from './47acb958c05758e30a34a4ecca392fda35867094ff2b705c30f618cee450a279.cfe-internal.js';

function useMonitorOutput(monitor, collect, onCollect) {
  var _useCollector = useCollector(monitor, collect, onCollect),
    _useCollector2 = _slicedToArray(_useCollector, 2),
    collected = _useCollector2[0],
    updateCollected = _useCollector2[1];
  useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
    var handlerId = monitor.getHandlerId();
    if (handlerId == null) {
      return;
    }
    return monitor.subscribeToStateChange(updateCollected, {
      handlerIds: [handlerId]
    });
  }, [monitor, updateCollected]);
  return collected;
}

export { useMonitorOutput };
